import PinInput from './PinInput'
import PinInputField from './PinInputField'

export default PinInput
export { PinInputField }
